<script lang="ts" setup>
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const router = useRouter();
const route = useRoute();
const azureAdLogoutUrl = `https://login.microsoftonline.com/031e81af-bb46-4833-a61c-f97d61318316/oauth2/v2.0/logout?post_logout_redirect_uri=${window.location.origin}`;

onMounted(() => {
  if (route.query.azureAd) {
    window.location.href = azureAdLogoutUrl;
    return;
  }
  router.replace('/');
});
</script>

<template>
  <n-card
    mx-auto
    my-4
    max-w-500px
  >
    <div text-center>
      <n-spin size="small" />
    </div>
    <div
      mt-3
      text-center
    >
      Disconnecting...
    </div>
  </n-card>
</template>
